Array.prototype.count = function(value) {
  var sum = 0;
  this.forEach(index => {
    if (index === value) sum++;
  });
  return sum;
};

Array.prototype.containsKey = function(key = '') {
  return key in this;
};

Array.prototype.flatten = function() {
  function flatten(arr) {
    return arr.reduce(function(flat, toFlatten) {
      return flat.concat(
        Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten,
      );
    }, []);
  }

  return flatten(this);
};
